import type { FaireProductEntity } from "../../entity_types/product";

export const p_sfe6wp3yn6: FaireProductEntity = {
  token: "p_sfe6wp3yn6",
  type: "product",
  name: "autumn watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/d87d4925eb22466d9647da6aa8d49828892edea2e5af114688d363241d44e980.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0073eb9722526b7e07dd83a25192996897968a328fdebaf596780914dde96a7.jpeg",
    "https://cdn.faire.com/fastly/44aeb59106592a8b1bb13b349347f960ce246d2b07c0d166fb235e959b2637a2.jpeg",
    "https://cdn.faire.com/fastly/742e1a7d87d0064eaa73836e081117b1ffc08d0219400874bb5d8972d1beae06.jpeg",
    "https://cdn.faire.com/fastly/e754d8271dab1687c2023e560101c0ff7cd5926894969d8a2d821a4a1cf45c8e.jpeg",
    "https://cdn.faire.com/fastly/7dc9a5f9ed2a4dd35d13f85cd8023bcb244da2d0a5e246412b08f02383bd2359.jpeg",
    "https://cdn.faire.com/fastly/977db710a623c8be30364f7c63ef8ab62261953ee435b422ab9664c5d502a2a2.jpeg",
    "https://cdn.faire.com/fastly/5f28c6ab5427179175b8fefcbda2fca291e5eb7ad79e6850d282a7005e6c7105.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve autumn illustrations — a pumpkin, squirrel, fall leaves, vintage truck, mum bouquet, fall wreath, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong fall seller. Reorder by late August. Performs well in home and seasonal-gift boutiques.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:06.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
